module.exports = __webpack_public_path__ + "c0c3f6c633e409bb9cfbbb9d7d7cef85.png";